import { render, staticRenderFns } from "./Vessels.vue?vue&type=template&id=e9747014&"
import script from "./Vessels.vue?vue&type=script&lang=js&"
export * from "./Vessels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports